// IMPORTANT: Polyfill must be first to intercept navigator.storage before any service imports it
import "./utils/opfs-polyfill";

import { createRoot } from "react-dom/client";
import { App } from "./App";
import { setupDebugControls } from "debugx";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Set up debug controls
setupDebugControls();

// Mount the app
const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}

// Register service worker for PWA
serviceWorkerRegistration.register();
